/**
 * Share-with-a-parent button.
 *
 * This is the only interactive element on the For Students page and it
 * deliberately collects nothing. No email field, no booking widget, no form of
 * any kind — every enrolment path on this site runs through an adult, and the
 * Children's Online Privacy Code means we take nothing from a minor.
 *
 * navigator.share hands off to the operating system's own share sheet. We never
 * see who it goes to, and nothing leaves the device through us. The clipboard
 * fallback is the same deal.
 *
 * Progressive enhancement throughout: the page URL is printed on the page as
 * plain text, so with no JavaScript at all a student can still read it out or
 * copy it by hand. The button only ever makes that easier.
 */
(function () {
  var buttons = document.querySelectorAll('[data-share]');
  if (!buttons.length) return;

  function flash(button, message) {
    var original = button.getAttribute('data-share-label') || button.textContent;
    button.textContent = message;
    window.setTimeout(function () {
      button.textContent = original;
    }, 2400);
  }

  buttons.forEach(function (button) {
    // Trimmed: Liquid indentation would otherwise be restored as the label.
    button.setAttribute('data-share-label', button.textContent.trim());

    button.addEventListener('click', function () {
      var url = button.getAttribute('data-share-url') || window.location.href;
      var title = button.getAttribute('data-share-title') || document.title;
      var text = button.getAttribute('data-share-text') || '';

      if (navigator.share) {
        navigator.share({ title: title, text: text, url: url }).catch(function () {
          // A cancelled share sheet rejects. That is a choice, not a failure.
        });
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(
          function () {
            flash(button, 'Link copied');
          },
          function () {
            flash(button, 'Copy the link below');
          }
        );
        return;
      }

      flash(button, 'Copy the link below');
    });
  });
})();
